import React from "react";
import { useDispatch, useSelector } from "react-redux";
import "./playlistcard.css";
import { ReactComponent as DeleteIcon } from "../../../../Assets/images/delete.svg";
import { ReactComponent as CreateIcon } from "../../../../Assets/images/createicon.svg";
import { Box } from "@mui/material";

function PlaylistCard(props) {
  const { play, addContentModel, deleteWholePlaylist, children } = props;

  return (
    <div className="playlist-cards">
      {/* 카드 헤더: 플레이리스트 이름 + 버튼 */}
      <div className="playlist-cards-header">
        <span className="playlist-cards-title">{play.name}</span>
        <div className="playlist-cards-header-actions">
          <button
            className="playlist-header-btn playlist-header-btn--add"
            onClick={() => addContentModel(play._id, play?.activescreen?.mac)}
            title="콘텐츠 추가"
          >
            <CreateIcon style={{ width: 16, height: 16 }} />
            추가
          </button>
          <button
            className="playlist-header-btn playlist-header-btn--delete"
            onClick={() => deleteWholePlaylist(play._id, play?.activescreen?.mac)}
            title="플레이리스트 삭제"
          >
            <DeleteIcon style={{ width: 16, height: 16 }} />
            삭제
          </button>
        </div>
      </div>

      {/* 컨텐츠 리스트 */}
      <div className="playlist-card-body">
        {React.Children.count(children) === 0 ? (
          <div className="playlist-card-empty">콘텐츠가 없습니다. 추가해주세요.</div>
        ) : (
          <div className="pci-list">
            {/* 리스트 헤더 */}
            <div className="pci-list-header">
              <span style={{ width: 64 }}>미리보기</span>
              <span style={{ flex: 1 }}>파일명</span>
              <span style={{ width: 70, textAlign: 'center' }}>재생시간</span>
              <span style={{ width: 72, textAlign: 'center' }}>액션</span>
            </div>
            {children}
          </div>
        )}
      </div>
    </div>
  );
}

export default PlaylistCard;
